// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"5ae01800","988":"eb9b158b"}[chunkId] + ".chunk.js";
};